import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

interface ITagsAutocompleteProps {
    componentId: string;
    className?: string;
    list: Immutable.List<KeyValuePair<number, string>>;
    selectedValue: Immutable.List<any>;
    selectionOp: number;
    disabled?: boolean;
    focusOnLoad?: boolean;
    autoClose?: boolean;
}

class TagsAutocompleteState { }

class Autocomplete extends React.Component<ITagsAutocompleteProps, TagsAutocompleteState> {
    private selector: JQuery;
    private dataSource: kendo.data.DataSource;

    constructor(props: ITagsAutocompleteProps) {
        super(props);
        this.dataSource = new kendo.data.DataSource();
    }

    public render(): JSX.Element {
        return (
            <select
                disabled={this.props.disabled}
                id={this.props.componentId}
                className={this.props.className}
                multiple
            />
        );
    }

    public componentDidMount(): void {
        if (this.props.list != null && this.props.list.size > 0) {
            this.dataSource.data(this.props.list.toArray());
        }

        var self = this;
        var revealDom = $("#" + this.props.componentId);
        // init kendo multiselect
        this.selector = $(revealDom).kendoMultiSelect({
            dataTextField: "Value",
            dataValueField: "Key",
            dataSource: self.dataSource,
            autoClose: (this.props.autoClose) ? this.props.autoClose : false,
            clearButton: false,
            filter: "contains",
            change: e => {
                var operation = new LocalEvent(self.props.selectionOp);
                operation.AddItem("value", e.sender.value());
                LocalEventDispatcher.dispatch(operation);
            }
        });

        if (this.props.selectedValue.size > 0) {
            this.selector.data("kendoMultiSelect").value(this.props.selectedValue.toArray());
        }
        if (this.props.focusOnLoad) {
            this.selector.data("kendoMultiSelect").focus();
        }
    }

    public shouldComponentUpdate(nextProps: ITagsAutocompleteProps): boolean {
        var selectionChanged = this.props.selectedValue !== nextProps.selectedValue;
        if (this.props.list != nextProps.list)
            return true;
        return selectionChanged;
    }

    public componentDidUpdate(): void {
        this.dataSource.data(this.props.list.toArray());
        this.selector.data("kendoMultiSelect").dataSource.filter({});
        this.selector.data("kendoMultiSelect").value(this.props.selectedValue.toArray());
    }

    public componentWillUnmount(): void {
        this.selector.data("kendoMultiSelect").destroy();
    }
}

export { Autocomplete };
